import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import PropTypes from 'prop-types'
import { Badge, TooltipUtils } from 'mailup-web-components'

import {
  RCS_QUEUING_ERROR,
  RCS_QUEUING_RUNNING,
  RCS_SCHEDULED_READY,
  RCS_SENDING_ERROR,
  RCS_SENDING_FAILED,
  RCS_SENDING_NO_CREDIT,
  RCS_SENDING_READY,
  RCS_SENDING_RUNNING,
  RCS_SENDING_STOPPED,
  RCS_SENDING_STOPPING
} from 'Api/beRcsSend'
import { fromUTCtoZoneFormatted, getLang } from 'mailup-react-helpers'

const Status = ({ state, scheduleDate, UITimezone }) => {
  const intl = useIntl()
  const lang = getLang()

  useEffect(() => {
    setTimeout(() => {
      TooltipUtils.rebuild()
    })
  }, [state])

  useEffect(() => {
    setTimeout(() => {
      TooltipUtils.rebuild()
    })
  }, [])

  const setText = val => {
    switch (val) {
      case RCS_QUEUING_RUNNING:
        return intl.formatMessage({
          id: 'Load.Rcs.SendStatusStateQueuing'
        })
      case RCS_QUEUING_ERROR:
        return intl.formatMessage({
          id: 'Load.Rcs.SendStatusStateQueueError'
        })
      case RCS_SENDING_READY:
        return intl.formatMessage({
          id: 'Load.Rcs.SendStatusStateReady'
        })
      case RCS_SENDING_RUNNING:
        return intl.formatMessage({
          id: 'Load.Rcs.SendStatusStateSending'
        })
      case RCS_SENDING_ERROR:
        return intl.formatMessage({
          id: 'Load.Rcs.SendStatusStateSendingError'
        })
      case RCS_SENDING_NO_CREDIT:
        return intl.formatMessage({
          id: 'Load.Rcs.SendStatusStateNoCredits'
        })
      case RCS_SCHEDULED_READY:
        return intl.formatMessage({
          id: 'Load.Rcs.SendStatusStateScheduled'
        })
      case RCS_SENDING_STOPPING:
        return intl.formatMessage({
          id: 'Load.Rcs.SendStatusStatePauseInProgress'
        })
      case RCS_SENDING_STOPPED:
        return intl.formatMessage({
          id: 'Load.Rcs.SendStatusStatePaused'
        })
      case RCS_SENDING_FAILED:
        return intl.formatMessage({
          id: 'Load.Rcs.SendStatusStateFailed'
        })
    }
  }

  const setType = val => {
    switch (val) {
      case RCS_QUEUING_RUNNING:
      case RCS_SENDING_READY:
        return 'default'

      case RCS_QUEUING_ERROR:
      case RCS_SENDING_FAILED:
        return 'error'

      case RCS_SENDING_RUNNING:
      case RCS_SCHEDULED_READY:
        return 'info'

      case RCS_SENDING_NO_CREDIT:
      case RCS_SENDING_STOPPING:
      case RCS_SENDING_STOPPED:
      case RCS_SENDING_ERROR:
        return 'warning'
    }
  }

  const setTooltipText = val => {
    if (val === RCS_QUEUING_ERROR) {
      return intl.formatMessage({
        id: 'Load.Rcs.SendStatusStateQueueErrorTooltip'
      })
    }
    if (val === RCS_SENDING_ERROR) {
      return intl.formatMessage({
        id: 'Load.Rcs.SendStatusStateQueueRetryTooltip'
      })
    }
    if (val === RCS_SCHEDULED_READY) {
      return (
        fromUTCtoZoneFormatted(
          scheduleDate,
          UITimezone,
          'YYYY-MM-DD HH:mm',
          lang
        ) +
        ' (' +
        UITimezone.split('.')[0] +
        ')'
      )
    }
  }

  return (
    <span data-tip={setTooltipText(state)}>
      <Badge text={setText(state)} type={setType(state)} />
    </span>
  )
}

export default Status

Status.propTypes = {
  state: PropTypes.string,
  scheduleDate: PropTypes.string,
  UITimezone: PropTypes.string
}

// const StyledTextTotal = styled(Text)`
//   font-size: 14px !important;
// `
